import { baseUrl_SPB } from '../../BaseUrl';

const TRADE_JOB_GET_ENDPOINTS = [
  '/api/v1/tradejob/retrievetradejobs',
  '/api/v1/tradejob/gettradejobs',
  '/api/v1/tradejob/getall',
];

function normalizeJobsPayload(payload) {
  if (Array.isArray(payload)) return payload;
  if (payload && Array.isArray(payload.data)) return payload.data;
  if (payload && Array.isArray(payload.content)) return payload.content;
  if (payload && Array.isArray(payload.items)) return payload.items;
  return [];
}

export default async function FetchTradeJobs(token) {
  const tokenv = token ? token.toString() : '';
  let lastError = null;

  for (let i = 0; i < TRADE_JOB_GET_ENDPOINTS.length; i += 1) {
    const endpoint = TRADE_JOB_GET_ENDPOINTS[i];
    try {
      const response = await fetch(`${baseUrl_SPB}${endpoint}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + tokenv,
        },
      });

      if (!response.ok) {
        lastError = new Error(`Request failed (${response.status}) for ${endpoint}`);
        continue;
      }

      const jsonResponse = await response.json();
      return normalizeJobsPayload(jsonResponse);
    } catch (error) {
      lastError = error;
    }
  }

  console.error('Error fetching trade jobs:', lastError);
  return [];
}
